import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ModalHeaderLeft');

function ModalHeaderLeft({ name, ...props }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Text type="subtitle1" className={classes.text}>
                {name}
            </Text>
        </div>
    );
}

ModalHeaderLeft.propTypes = {
    name: PropTypes.string,
};

export default memo(ModalHeaderLeft);
